import { NotifyHelper } from "../../../helpers/toast";
import { eDangKyChuyenNganhActionsObj } from "../../action-types/dang-ky-chuyen-nganh/IDangKyChuyenNganhActions";
import { generateActionForKey, generateActions } from "../generateActions";

const PREFIX = "DANG_KY_CHUYEN_NGANH";

export const dangKyChuyenNganhActions = {
  ...generateActions(eDangKyChuyenNganhActionsObj, PREFIX),

  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "SAVE_DOT_SUCCESS", () => {
    NotifyHelper.Success("Lưu đợt thành công");
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "SAVE_DOT_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "DELETE_DOT_SUCCESS", () => {
    NotifyHelper.Success("Xoá đợt thành công");
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "DELETE_DOT_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "SUBMIT_THIET_LAPS_SUCCESS", () => {
    NotifyHelper.Success("Lưu thiết lập thành công");
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "SUBMIT_THIET_LAPS_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "SUBMIT_NGUYEN_VONG_SUCCESS", () => {
    NotifyHelper.Success("Lưu nguyện vọng thành công");
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "SUBMIT_NGUYEN_VONG_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "DELETE_KET_QUA_DANG_KY_SUCCESS", () => {
    NotifyHelper.Success("Xoá kết quả đăng ký thành công");
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "DELETE_KET_QUA_DANG_KY_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "XET_TU_DONG_SUCCESS", (count) => {
    NotifyHelper.Success(`Xét tự động xong: ${count} sinh viên`);
  }),
  ...generateActionForKey(eDangKyChuyenNganhActionsObj, PREFIX, "XET_TU_DONG_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
